window.axios = require('axios');

/**
 * Определяет валидыне коды ответа для axios по умолчанию
 * P.S. По какой-то причине не работает внутри нижнего конфига.
 */

axios.defaults.validateStatus = (status) => {
    return status >= 200 && status < 400;
};

/**
 * Конфигурация axios по умолчанию.
 */

axios.defaults = {

    /**
     * Базовый URL-адрес запроса.
     */
    baseURL: window.location.origin,

    /**
     * Заголовки запроса.
     */
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    /**
     * Обрабатывает полученный ответ.
     *
     * @param {object} response
     */
    onResponse (response) {
        const { status, data } = response;

        const redirectStatusHandlers = {
            302: this.onRedirect,
        };
        if (status in redirectStatusHandlers) {
            redirectStatusHandlers[status](response);
        }

        if (data && data.notification) {
            const { notification } = data;

            Vue.notify({
                group: 'main',
                type: notification.type || 'light',
                title: notification.title,
                text: notification.text,
                data: notification.data,
                duration: notification.duration,
            });
        }

        // TODO: Добавить обработку уведомлений и алертов

        return response;
    },

    /**
     * Обрабатывает сообщение об ошибке, полученное по совершенному запросу.
     *
     * @param {object} error
     */
    onError (error) {
        const { response } = error;

        const errorStatusHandlers = {
            401: this.onUnauthorized,
            403: this.onForbidden,
            404: this.onNotFound,
            419: this.onSessionExpired,
            422: this.onValidationError,
            429: this.onTooManyRequests,
            500: this.onServerError,
            503: this.onUnavailable,
        };

        const { status } = response;
        if (status in errorStatusHandlers) {
            errorStatusHandlers[status](error);
        } else {
            this.onGenericError(error);
        }

        return Promise.reject(error);
    },

    /**
     * Обрабатывает код перенаправления 302 (временное перенаправление).
     *
     * @param {object} response
     */
    onRedirect (response) {
        const { data } = response;

        if (data && data.redirectPath) {
            window.location.href = window.location.origin + data.redirectPath;
        } else {
            console.error('Получен код перенаправления ' + status + '. Однако значение свойства redirectPath, ' +
                'указывающее на конечный адрес не было установлено.')
        }

        return response;
    },

    /**
     * Обрабатывает ошибку 401 (пользователь не авторизован).
     *
     * @param {object} error
     */
    onUnauthorized (error) {
        swal({
            icon: "error",
            title: "Вы не авторизованы",
            text: "Извините, но для выполнения данного действия необходимо авторизироваться на сайте.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

    /**
     * Обрабатывает ошибку 403 (отказано в доступе).
     *
     * @param {object} error
     */
    onForbidden (error) {
        swal({
            icon: "error",
            title: "Отказано в доступе",
            text: "Извините, но Вам отказано в доступе.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

    /**
     * Обрабатывает ошибку 404 (по запросу ничего не найдено).
     *
     * @param {object} error
     */
    onNotFound (error) {
        swal({
            icon: "error",
            title: "По запросу ничего не найдено",
            text: "Извините, но запрашиваемая Вами страница не была найдена.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

    /**
     * Обрабатывает ошибку 419 (сессия пользователя истекла).
     *
     * @param {object} error
     */
    onSessionExpired (error) {
        swal({
            icon: "error",
            title: "Время сеанса истекло",
            text: "Извините, но время Вашего сеанса истекло. Пожалуйста, обновите страницу и попробуйте снова.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

    /**
     * Обрабатывает ошибку 422 (код используемый Laravel для обозначения ошибки валидации).
     *
     * @param {object} error
     */
    onValidationError (error) {
        return error;
    },

    /**
     * Обрабатывает ошибку 429 (слишком много запросов).
     *
     * @param {object} error
     */
    onTooManyRequests (error) {
        swal({
            icon: "error",
            title: "Слишком много запросов",
            text: "Извините, но Вы сделали слишком много запросов к серверу.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

    /**
     * Обрабатывает ошибку 500 (ошибка на сервере).
     *
     * @param {object} error
     */
    onServerError (error) {
        swal({
            icon: "error",
            title: "Ошибка на сервере",
            text: "Извините, но на нашем сайте произошла ошибка.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

    /**
     * Обрабатывает ошибку 503 (сервер недоступен).
     *
     * @param {object} error
     */
    onUnavailable (error) {
        swal({
            icon: "error",
            title: "Сервер недоступен",
            text: "Извините, но в данный момент на сайте проводятся технические работы. Вернитесь чуть позже.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

    /**
     * Обрабатывает общие ошибки (для которых не предусмотрен индивидуальный обработчик).
     *
     * @param {object} error
     */
    onGenericError (error) {
        swal({
            icon: "error",
            title: "Ошибка",
            text: "Извините, произошла ошибка.",
            button: {
                text: "Хорошо",
                value: true,
                visible: true,
                className: "btn btn-danger",
                closeModal: true,
            }
        });

        return error;
    },

};

/**
 * Добавление перехватчика ответа.
 */

axios.interceptors.response.use(
    response => axios.defaults.onResponse(response),
    error => axios.defaults.onError(error)
);

/**
 * Добавление CSRF-токена к заголовкам запроса.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('Не найден CSRF-токен: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}